export const getToken = () => {
    return localStorage.getItem('loginToken');
  };

  export const capitalizeFirstLetter = (str) => {
    if (!str) return str; // Handle empty or null strings
    return str.charAt(0).toUpperCase() + str.slice(1);
};